import { createSelector } from 'reselect'
const querystring = require('querystring')

export const selectRouting = (state) => state.router

export const selectLocation = createSelector(
  selectRouting,
  (routing) => {
    if (!routing || !routing.location) {
      return undefined
    }
    const query = querystring.parse(routing.location.search.substring(1))
    return { ...routing.location, query }
  }
)

export const selectPathname = createSelector(
  selectLocation,
  (location) => location && location.pathname,
)

export const selectQuery = createSelector(
  selectLocation,
  (location) => location && location.query,
)
